import React from 'react'
import filter from 'lodash/filter'
// Local
import { CONDITION } from '../../../constant'
import {
  EncounterConditionDisplay,
  EncounterConditionDisplayModified,
  EncounterConditionRuleRow
} from '../../authenticated/types'

type Props = {
  condition: EncounterConditionDisplay | EncounterConditionDisplayModified
}

function ConditionReasons(
  props: Props
): JSX.Element | null {
  const { condition } = props

  if (!condition.rules) return null

  return (
    <>
      {
        filter(
          condition.rules,
          (rule: EncounterConditionRuleRow) => (
            rule.statusCode === CONDITION.STATUS.ACTIVE &&
            rule.reason !== condition.content
          )
        ).map((rule: EncounterConditionRuleRow): JSX.Element => {
          const key = rule.id
            ? rule.id
            : rule.reason
          return (
            <div
              key={ key }
              className="reason-row">
              <strong>
                { rule.reason }
              </strong>
            </div>
          )
        })
      }
    </>
  )
}

export default ConditionReasons
